// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import EnrichedSelectorController from "./enriched_selector_controller";
application.register("enriched-selector", EnrichedSelectorController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import NavMenuController from "./nav_menu_controller";
application.register("nav-menu", NavMenuController);

import PlanModalController from "./plan_modal_controller";
application.register("plan-modal", PlanModalController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import TabsController from "./tabs_controller";
application.register("tabs", TabsController);

import ToggleVisibilityController from "./toggle_visibility_controller";
application.register("toggle-visibility", ToggleVisibilityController);

import TomSelectController from "./tom_select_controller";
application.register("tom-select", TomSelectController);

import TurnstileController from "./turnstile_controller";
application.register("turnstile", TurnstileController);
